import { render, staticRenderFns } from "./AdmissionsJournalGrid.vue?vue&type=template&id=ce92b308"
import script from "./AdmissionsJournalGrid.vue?vue&type=script&lang=js"
export * from "./AdmissionsJournalGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports